import burger from '../header-menu/burger';

export default new (class HeaderScroll {
    constructor() {
        this.height = 200;
        this.sHeaderScrollClass = '_pagination--scroll';
        this.sHeaderScrollActiveClass = '_pagination--active';
        this.sHeaderScrollAnimateClass = '_pagination--animate';

        this.initHandler()
    }

    /**
     * @description Init handler.
     */
    initHandler() {
        if(window.innerWidth >= 1200) {
            document.addEventListener("scroll", () => {
                this.scroll();
            });
            document.addEventListener("DOMContentLoaded", () => {
                this.scroll();
            });
        }
    }

    scroll() {
        if (window.pageYOffset < this.height) {
            if(document.querySelector(`.${this.sHeaderScrollClass}`).classList.contains(this.sHeaderScrollActiveClass)) {
                burger.burgerMenuClose();

                document.querySelector(`.${this.sHeaderScrollClass}`).classList.remove(this.sHeaderScrollActiveClass)
                document.querySelector(`.${this.sHeaderScrollClass}`).classList.remove(this.sHeaderScrollAnimateClass)

                //animate
                document.querySelector(`.${this.sHeaderScrollClass}`).classList.add('translate-y-[-225px]')
                document.querySelector(`.${this.sHeaderScrollClass}`).classList.add('opacity-0')
                document.querySelector(`.${this.sHeaderScrollClass}`).classList.add('invisible')
            }
        } else {
            if(!document.querySelector(`.${this.sHeaderScrollClass}`).classList.contains(this.sHeaderScrollActiveClass)) {

                document.querySelector(`.${this.sHeaderScrollClass}`).classList.add(this.sHeaderScrollActiveClass)
                document.querySelector(`.${this.sHeaderScrollClass}`).classList.add(this.sHeaderScrollAnimateClass)

                //animate
                document.querySelector(`.${this.sHeaderScrollClass}`).classList.remove('translate-y-[-225px]')
                document.querySelector(`.${this.sHeaderScrollClass}`).classList.remove('opacity-0')
                document.querySelector(`.${this.sHeaderScrollClass}`).classList.remove('invisible')

                burger.burgerMenuClose();
            }
        }
    }
})()
